import { t } from "i18next";
import * as yup from "yup";

export const driverValidationSchema = yup.object({
  id: yup.string().nullable(),
  firstname: yup
    .string()
    .required(t("The driver first name is requited"))
    .min(3, t("The driver first name field should contain at least 3 letters"))
    .test(
      "match",
      t("The driver first name field cannot contain numbers"),
      (value) => (value ? /^[^0-9*]+$/i.test(value) : true)
    )
    .test(
      "match",
      t("The driver first name cannot contain special symbols other than '-'"),
      (value) => (value ? /^[a-z- ]+$/i.test(value) : true)
    ),
  lastname: yup
    .string()
    .required(t("The driver last name is requited"))
    .min(3, t("The driver last name field should contain at least 3 letters"))
    .test(
      "match",
      t("The driver last name field cannot contain numbers"),
      (value) => (value ? /^[^0-9*]+$/i.test(value) : true)
    )
    .test(
      "match",
      t("The driver last name cannot contain special symbols other than '-'"),
      (value) => (value ? /^[a-z- ]+$/i.test(value) : true)
    ),
  phoneNumber: yup
    .string()
    .required(t("Phone number is requited"))
    .min(
      13,
      t("Invalid phone number format. Please use the format +234-XXX-XXXXXXX.")
    ),
  password: yup
    .string()
    .when("id", {
      is: undefined,
      then: () =>
        yup
          .string()
          .required(t("Password is requited"))
          .min(8, t("Password must be at least 8 characters long"))
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-:^#]{8,}$/,
            t(
              "Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
            )
          )
    })
    .test("min", t("Password must be at least 8 characters long"), (value) =>
      value ? value.length >= 8 : true
    )
    .test(
      "match",
      t(
        "Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
      ),
      (value) =>
        value
          ? /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-:^#]{8,}$/.test(
              value
            )
          : true
    ),
  repeatPassword: yup
    .string()
    .oneOf([yup.ref("password")], t("Passwords must match")),

  address: yup
    .string()
    .required(t("The Address field is requited"))
    .min(5, t("The Address field should contain at least 5 characters")),

  capacity: yup
    .number()
    .typeError(t("The Capacity field must be a number"))
    .required(t("The Capacity field is requited")),
  priority: yup
    .number()
    .typeError(t("The Priority field must be a number"))
    .required(t("The Priority field is requited")),
  totalCargoVolume: yup
    .number()
    .typeError(t("The Volume must positive, integer number"))
    .required(t("The Volume field is requited"))
    .integer(t("The Volume must positive, integer number"))
    .positive(t("The Volume must positive, integer number"))
    .max(1000, t("The Volume must not be greater than 1000")),
  totalCargoWeight: yup
    .number()
    .typeError(t("The Weight must positive, integer number"))
    .required(t("The Weight field is requited"))
    .integer(t("The Weight must positive, integer number"))
    .positive(t("The Weight must positive, integer number"))
    .max(10000, t("The Weight must not be greater than 10000")),
  birthdate: yup.date().required("The Date of Birth field is requited")
});
